// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-icon[data-v-db4781fc] {\n  width: 1rem;\n  height: 1rem;\n}\n.cap-icon[data-v-db4781fc] {\n  display: inline;\n  position: relative;\n  top: -0.1rem;\n  min-width: 1rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
